import React from "react";
import { Headset } from "lucide-react";

const FloatingWhatsApp = ({
  phone = "3124008320",
  message = "Hola, necesito soporte con mi solicitud de crédito.",
  show = true,
  tooltip = "Hablar con soporte",
}) => {
  if (!show) return null;

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
    message,
  )}`;

  return (
    <div
      className="
        fixed 
        z-9999
        group
        left-4        /* móvil */
        top-24         /* móvil */
        md:left-4     /* desktop */
        md:top-auto  /* desktop */
        md:bottom-8  /* desktop */
      "
    >
      {/* Tooltip */}
      <div
        className="
          absolute 
          left-full ml-3          /* móvil → tooltip a la derecha */
          md:left-auto md:left-full md:mr-3  /* desktop → tooltip a la izquierda */
          top-1/2 -translate-y-1/2
          px-3 py-1.5 text-sm rounded-lg
          bg-black/80 text-white shadow-lg
          opacity-0 group-hover:opacity-100
          pointer-events-none
          transition-all duration-200
          whitespace-nowrap
        "
        style={{
          backdropFilter: "blur(4px)",
          backgroundColor: "#fc3e58",
        }}
      >
        {tooltip}
      </div>

      {/* Botón flotante */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          backgroundColor: "#fc3e58",
          boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
          transition: "all 0.3s ease",
        }}
      >
        <Headset size={24} color="white" />
      </a>
    </div>
  );
};

export default FloatingWhatsApp;
